// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var inject = allVue.inject;
import { provideIntlService, provideLocalizationService } from '@progress/kendo-vue-intl';
import { messages, pagerInfo } from '../messages';
/**
 * Represents the default `PagerInfo` component.
 */

var PagerInfoVue2 = {
  name: 'KendoPagerInfo',
  props: {
    totalPages: Number,
    currentPage: Number,
    skip: Number,
    messagesMap: Function
  },
  inject: {
    kendoLocalizationService: {
      default: null
    },
    kendoIntlService: {
      default: null
    }
  },
  // @ts-ignore
  setup: !gh ? undefined : function () {
    var v3 = !!gh;
    var kendoIntlService = inject('kendoIntlService', {});
    var kendoLocalizationService = inject('kendoLocalizationService', {});
    return {
      v3: v3,
      kendoIntlService: kendoIntlService,
      kendoLocalizationService: kendoLocalizationService
    };
  },
  // @ts-ignore
  render: function render(createElement) {
    var h = gh || createElement;
    var intlService = provideIntlService(this);
    var localizationService = provideLocalizationService(this);
    var infoMessage = this.$props.messagesMap ? this.$props.messagesMap(pagerInfo) : {
      messageKey: pagerInfo,
      defaultMessage: messages[pagerInfo]
    };
    return h("div", {
      "class": "k-pager-info k-label"
    }, [intlService.format(localizationService.toLanguageString(infoMessage.messageKey, infoMessage.defaultMessage), [Math.min(this.$props.skip + 1, this.$props.totalPages), Math.min(this.$props.skip + this.$props.currentPage, this.$props.totalPages), this.$props.totalPages])]);
  }
};
var PagerInfo = PagerInfoVue2;
export { PagerInfo, PagerInfoVue2 };